/**
 * react-chartjs-2 forwards the Chart.js instance directly; older wrappers exposed `.chart`.
 * @param {import('chart.js').Chart | { chart?: import('chart.js').Chart } | null | undefined} refEntry
 * @returns {import('chart.js').Chart | null}
 */
export function resolveChartJsInstance(refEntry) {
  if (!refEntry) return null;
  if (refEntry.canvas) return refEntry;
  return refEntry.chart ?? null;
}
